import React from 'react';

class Divider extends React.Component {
    render() {
        const {color, icon} = this.props;

        if (icon)
            return (
                <div className={`divider-icon divider-margins bg-${color}`}>
                    <i className={`fa font-17 fa-user color-${color}`}></i>
                </div>
            );

        return (
            <div className={`divider divider-margins bg-${color}`}>
            </div>
        );
    }
}

export default Divider;

